import { createSlice } from '@reduxjs/toolkit';
import { getAnyUnreadNotifications } from '../../services/notification/notifications.service';
import { AppDispatch } from '../../store';

export interface NotificationsState {
  anyUnreadNotificationsFound: boolean;
}

const initialState: NotificationsState = {
  anyUnreadNotificationsFound: false,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    updateAnyUnreadNotificationsFound: (state, action: { type: string; payload: boolean }) => {
      return { ...state, anyUnreadNotificationsFound: action.payload };
    },
  },
});

const initAnyUnreadNotificationsFound = () => {
  return (dispatch: AppDispatch) => {
    getAnyUnreadNotifications().then((response) => {
      dispatch(notificationsSlice.actions.updateAnyUnreadNotificationsFound(response.data));
    });
  };
};

export const notificationsActions = { ...notificationsSlice.actions, initAnyUnreadNotificationsFound };
export default notificationsSlice;
